<!-- Solcre: data-view switches between "card" and "list" -->
<div class="c-routes" [attr.data-view]="activeRouteView()">
    <div class="c-routes__scrollable">
        <div class="c-routes__list">
            <app-voyage-routes-segment (addPortCall)="onAddPortCall(0)" />

            @for (portCall of activeVoyage()?.portCalls; track $index) {
            <app-voyage-routes-portcall [portCall]="portCall" [showing]="portCall.id == activePortCall()?.id"
                [next]="portCall.id == nextPortCall()?.id" (addPortCall)="onAddPortCall(portCall?.sequenceOrder ?? 0)"
                (changeAsActive)="onChangePortCallAsActive(portCall)" (editPortCallAction)="onEditPortCall(portCall)"
                (editNauticalMileDistanceAction)="onEditNauticalMileDistance(portCall)"
                (deletePortCallAction)="onDeletePortCall(portCall)" (changeStatus)="onChangeStatus($event)"
                (expensesUpdated)="onExpensesUpdated($event)" (addExpensesAction)="onAddExpenses(portCall)"
                (speedSelectionUpdated)="onSpeedSelectionUpdated($event)" (addSpeedSelectionAction)="onAddSpeedSelection(portCall)" />
            <app-voyage-routes-segment (addPortCall)="onAddPortCall(portCall?.sequenceOrder ?? 0)" />
            }
        </div> <!-- .c-routes__list -->

    </div> <!-- .c-routes__scrollable -->
</div> <!-- .c-routes -->
